var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("SPORT")]),_c('Chronometer',{on:{"play":_vm.onChronoPlay,"pause":_vm.onChronoPause}}),_c('Maths',{attrs:{"isChronoPlaying":_vm.isChronoPlaying}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }